import Add from "../components/global/ad";
import Minipost from "../components/global/minipost";
import { db } from "../firebase";
import { useState, useEffect } from "react";
import CategoryList from "../components/caregories/category";

const Blog = () => {
  const [newBlogs, setNewBlogs] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/posts");
    ref
      .orderBy("createdate", "desc")
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          var storedDate = new Date(doc.data().createdate.toDate());
          var nowDate = new Date();
          var elapsedTime = nowDate.getTime() - storedDate.getTime();
          documents.push({ ...doc.data(), id: doc.id, timeAgo: elapsedTime });
        });
        setNewBlogs(documents);
      });
  }, []);
  const [categories, setCategories] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/Category");
    ref
      .orderBy("createdate", "desc")
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setCategories(documents);
      });
  }, []);
  return (
    <div className="blog-page">
      <div className="mini-category">
        <div className="container">
          <h1>اخر المقالات</h1>
          <div className="wrap">
            <Minipost blogs={newBlogs} />
          </div>
        </div>
      </div>
      <Add />
      {categories &&
        categories.map((category) => {
          return <CategoryList key={category.id} catego={category} />;
        })}
    </div>
  );
};

export default Blog;
